import React, {useEffect, useRef, useState} from "react";
import 'video.js/dist/video-js.css';
import {getTmdbImage, TORRESOWO_URL} from "../../../utils/consts";
import {getAudioFromMetadata, getDurationFromMetadata, getSubtitlesFromMetadata} from "../../../utils/utils";
import './squadflixVideoPlayer.css';
import CustomFilePlayer from "../squadflixVideoView/customFilePlayer/customFilePlayer";
import {TorresstreamApi} from "../../../apis/torrestream-api/torresstream-api";

function SquadflixVideoPlayer({posterPath, onReady, file, item, onGoNextEpisode, squadFlixTvHook}) {

    const [duration, setDuration] = useState(0);
    const [subtitles, setSubtitles] = useState([]);
    const [audios, setAudios] = useState([]);
    const [originalVideourl, setOriginalVideoUrl] = useState("");
    const lastLoadedFile = useRef(null);

    useEffect(() => {
        if (!file || lastLoadedFile.current === file) {
            return;
        }

        if (item.serie) {
            setOriginalVideoUrl(`${TORRESOWO_URL}/squadflix/${item.serie?.id}_${item.season_number}_${item.episode_number}.mp4`);
        } else {
            setOriginalVideoUrl(`${TORRESOWO_URL}/squadflix/${item.id}.mp4`);
        }
        TorresstreamApi.get('streamSquadDiskFile').call({filePath: file.url, fetchMetadata: true}).then(res => {
            setDuration(getDurationFromMetadata(res.metadata, item));
            setSubtitles(getSubtitlesFromMetadata(res.metadata));
            setAudios(getAudioFromMetadata(res.metadata));
            lastLoadedFile.current = file;
        });
    }, [file, item]);

    return (
        <CustomFilePlayer
            onGoNextEpisode={onGoNextEpisode}
            audios={audios}
            subtitles={subtitles} item={item}
            videoUrl={TorresstreamApi.get('streamSquadDiskFile').getUrl({filePath: file.url})}
            originalVideoUrl={originalVideourl}
            squadFlixTvHook={squadFlixTvHook}
            streaming={true} customRuntime={duration}
            imagePath={getTmdbImage(posterPath)} title={item.title ?? item.name}/>
    );
}

export default SquadflixVideoPlayer;
